/* Mitsi & Co cart drawer. AJAX add-to-cart against Shopify's cart API, with a
   localStorage demo fallback so the static review mirror stays fully clickable.
   Config arrives via window.NPDrawerData (set in theme.liquid). */
(function () {
  var D = window.NPDrawerData || {};
  var FREE_SHIP_CENTS = 3500;
  var demo = D.preview === true;
  var lastFocus = null;
  var uncertain = false;
  var checkoutStarted = false;
  var cartDirty = false;

  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function escapeHtml(value) { var span = document.createElement('span'); span.textContent = value || ''; return span.innerHTML.replace(/"/g, '&quot;'); }

  var memCart = { items: [] };
  function demoCart() {
    try { return JSON.parse(localStorage.getItem('np-demo-cart') || 'null') || memCart; }
    catch (e) { return memCart; }
  }
  function demoSave(c) {
    memCart = c;
    try { localStorage.setItem('np-demo-cart', JSON.stringify(c)); } catch (e) {}
  }
  function demoTotals(c) {
    var t = 0, n = 0, kitVest = 0, kitBoot = 0;
    c.items.forEach(function (i) {
      t += i.cents * i.qty; n += i.qty;
      if (i.handle === D.vestHandle) kitVest += i.qty;
      if (i.handle === D.bootiesHandle) kitBoot += i.qty;
    });
    var disc = Math.min(kitVest, kitBoot) * D.kitDiscount;
    return { total: t - disc, count: n, discount: disc };
  }

  function api(path, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + path.replace(/^\//, ''), {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var error = new Error(data.description || 'We could not update your cart. Please try again.'); error.confirmedFailure = true; throw error; }
        return data;
      });
    });
  }

  function el(id) { return document.getElementById(id); }

  function open() {
    lastFocus = document.activeElement;
    el('np-drawer').classList.add('open');
    el('np-scrim').classList.add('open');
    el('np-drawer').inert = false;
    document.body.style.overflow = 'hidden';
    el('npd-close').focus();
  }
  function close() {
    el('np-drawer').classList.remove('open');
    el('np-scrim').classList.remove('open');
    el('np-drawer').inert = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    if (cartDirty && document.body.classList.contains('template-cart')) window.location.reload();
  }

  function lineHtml(img, title, meta, priceHtml, controls) {
    return '<div class="npd-line">' +
      (img ? '<img src="' + escapeHtml(img) + '" alt="">' : '') +
      '<div><div class="t">' + escapeHtml(title) + '</div><div class="m">' + escapeHtml(meta) + '</div>' + (controls || '') + '</div>' +
      '<div class="p">' + priceHtml + '</div></div>';
  }

  function render(cart) {
    var items = el('npd-items');
    var hasBooties = false, hasVest = false, subtotal = 0, count = 0;
    var html = '';

    if (demo) {
      var c = demoCart(), t = demoTotals(c);
      subtotal = t.total; count = t.count;
      c.items.forEach(function (i, idx) {
        if (i.handle === D.vestHandle) hasVest = true;
        if (i.handle === D.bootiesHandle) hasBooties = true;
        html += lineHtml((window.MitsiVariantImages || {})[i.variantId] || i.img, i.title, i.meta + (i.qty > 1 ? ' · ×' + i.qty : ''), fmt(i.cents * i.qty),
          '<button class="rm" data-demo-rm="' + idx + '">Remove</button>');
      });
      if (t.discount) html += '<div class="npd-line"><div><div class="t">Walk Kit · extra ' + fmt(D.kitDiscount) + ' off</div><div class="m">Applied automatically when both items are in the cart</div></div><div class="p">−' + fmt(t.discount) + '</div></div>';
    } else {
      cart.items.forEach(function (i) {
        if (i.handle === D.vestHandle) hasVest = true;
        if (i.handle === D.bootiesHandle) hasBooties = true;
        var discounted = i.original_line_price > i.final_line_price;
        var priceHtml = discounted
          ? '<s style="color:var(--ink-mute);font-weight:400">' + fmt(i.original_line_price) + '</s><br>' + fmt(i.final_line_price)
          : fmt(i.final_line_price);
        if (i.handle === D.vestHandle && D.vestCompareCents > i.original_price) {
          priceHtml = '<s>' + fmt(D.vestCompareCents * i.quantity) + '</s><br>' + fmt(i.final_line_price) + '<span class="npd-savings">' + fmt((D.vestCompareCents - i.original_price) * i.quantity) + ' off</span>';
        }
        if (discounted) priceHtml += '<span class="npd-savings">Extra ' + fmt(i.original_line_price - i.final_line_price) + ' off</span>';
        html += lineHtml((window.MitsiVariantImages || {})[i.variant_id] || i.image, i.product_title,
          (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + (i.quantity > 1 ? ' · ×' + i.quantity : ''),
          priceHtml,
          lineControls(i));
      });
      subtotal = cart.total_price; count = cart.item_count;
    }

    items.innerHTML = html || '<div class="npd-empty">Your cart is empty.</div>';
    el('npd-count').textContent = count;
    el('npd-subtotal').textContent = fmt(subtotal);
    document.querySelectorAll('.nav-cart').forEach(function (n) { n.textContent = 'Cart (' + count + ')'; });

    var up = el('npd-upsell');
    if (up) up.style.display = (hasBooties || !hasVest) ? 'none' : '';
    var ship = el('npd-ship-msg'), bar = el('npd-bar-fill');
    if (subtotal >= FREE_SHIP_CENTS) {
      ship.innerHTML = '<strong>✓ Free standard US shipping unlocked</strong>';
      bar.style.width = '100%';
    } else {
      ship.innerHTML = 'Standard US shipping: <strong>$8</strong> · You’re <strong>' + fmt(FREE_SHIP_CENTS - subtotal) + '</strong> from free shipping';
      bar.style.width = Math.min(100, Math.round(subtotal * 100 / FREE_SHIP_CENTS)) + '%';
    }
    var co = el('npd-checkout');
    if (demo || !count) { co.setAttribute('aria-disabled', 'true'); co.textContent = demo ? 'Checkout unavailable in preview' : 'Your cart is empty'; co.removeAttribute('href'); }
    else { co.removeAttribute('aria-disabled'); co.textContent = 'Checkout'; co.href = '/checkout'; }
  }

  function refresh() {
    if (el('npd-error')) el('npd-error').hidden = true;
    if (demo) { render(null); return Promise.resolve(); }
    return api('/cart.js').then(render);
  }

  function addItems(items, metas, intent) {
    if (demo) {
      var c = demoCart();
      items.forEach(function (it, i) {
        var m = metas[i] || {};
        var existing = c.items.find(function (x) { return x.variantId === it.id; });
        if (existing) existing.qty += it.quantity;
        else c.items.push({ variantId: it.id, qty: it.quantity, title: m.title || 'Item', meta: m.meta || '',
                            img: m.img || '', cents: m.cents || 0, handle: m.handle || '' });
      });
      demoSave(c);
      return refresh().then(function () { if (intent === 'checkout') showError(new Error('Checkout is unavailable in preview. Your selections were added to the preview cart.')); else open(); });
    }
    if (uncertain) return Promise.reject(new Error('Check your cart before adding again. The previous update could not be confirmed.'));
    var submitted = false;
    var before;
    function count(cart, id) { return cart.items.filter(function (i) { return i.variant_id === id; }).reduce(function (n, i) { return n + i.quantity; }, 0); }
    return api('/cart.js').then(function (cart) {
      before = cart;
      submitted = true;
      return api('/cart/add.js', { items: items });
    }).then(function () { return api('/cart.js'); }).then(function (cart) {
      if (!items.every(function (item) { return count(cart, item.id) >= count(before, item.id) + item.quantity; })) {
        throw new Error('Your full selection could not be confirmed. Review your cart before continuing.');
      }
      render(cart);
      if (intent === 'checkout') { checkoutStarted = true; window.location.assign('/checkout'); return; }
      open();
    }).catch(function (error) {
      if (submitted) {
        uncertain = true;
        return api('/cart.js').then(function (cart) { render(cart); open(); }).catch(function () { open(); }).then(function () {
          throw new Error((error.confirmedFailure ? error.message + ' ' : '') + 'Check the items in your cart before continuing. The update could not be confirmed; it has not been retried.');
        });
      }
      throw error;
    });
  }

  function allowedVariants(item) {
    var list = item.handle === D.vestHandle ? D.vestVariants : item.handle === D.bootiesHandle ? D.bootiesVariants : [];
    return (list || []).filter(function (v) { return v.available && !(item.handle === D.bootiesHandle && ['Black', 'Yellow', 'Green'].indexOf(v.color) !== -1); });
  }
  function lineControls(item) {
    var variants = allowedVariants(item), edit = '';
    if (variants.length) {
      edit = '<details class="npd-edit"><summary>Edit</summary><label>Size and color<select data-edit-key="' + escapeHtml(item.key) + '" data-old-id="' + item.variant_id + '" data-qty="' + item.quantity + '" data-properties="' + escapeHtml(JSON.stringify(item.properties || {})) + '">';
      variants.forEach(function (v) { edit += '<option value="' + v.id + '"' + (v.id === item.variant_id ? ' selected' : '') + '>' + escapeHtml(v.color + ' / ' + v.size) + '</option>'; });
      edit += '</select></label><label>Quantity<input data-edit-qty type="number" min="1" value="' + item.quantity + '"></label><button type="button" class="npd-save-edit">Save</button></details>';
    }
    return edit + '<button class="rm" data-key="' + escapeHtml(item.key) + '">Remove</button>';
  }

  function swapLine(details) {
    cartDirty = true;
    var select = details.querySelector('select[data-edit-key]'), qty = parseInt(details.querySelector('[data-edit-qty]').value, 10);
    var oldKey = select.dataset.editKey, oldId = parseInt(select.dataset.oldId, 10), newId = parseInt(select.value, 10), properties = {};
    try { properties = JSON.parse(select.dataset.properties || '{}'); } catch (e) {}
    if (!qty || qty < 1) return Promise.reject(new Error('Choose a quantity of at least 1.'));
    if (newId === oldId) return api('/cart/change.js', { id: oldKey, quantity: qty }).then(refresh);
    var replacementAdded = false, original;
    function sameProperties(a, b) { var keys = Object.keys(a || {}).sort(); return JSON.stringify(keys.map(function (k) { return [k, a[k]]; })) === JSON.stringify(Object.keys(b || {}).sort().map(function (k) { return [k, b[k]]; })); }
    return api('/cart.js').then(function (cart) {
      original = cart.items.find(function (i) { return i.key === oldKey; });
      if (!original) throw new Error('This cart item changed. Close and reopen your cart, then try again.');
      var item = { id: newId, quantity: qty, properties: original.properties || {} };
      if (original.selling_plan_allocation) item.selling_plan = original.selling_plan_allocation.selling_plan.id;
      return api('/cart/add.js', { items: [item] });
    }).then(function () {
      replacementAdded = true;
      return api('/cart.js').then(function (cart) {
        var candidates = cart.items.filter(function (i) { return i.variant_id === oldId && sameProperties(i.properties, original.properties) && JSON.stringify(i.selling_plan_allocation || null) === JSON.stringify(original.selling_plan_allocation || null); });
        var stale = cart.items.find(function (i) { return i.key === oldKey; }) || (candidates.length === 1 ? candidates[0] : null);
        var added = cart.items.find(function (i) { return i.variant_id === newId && sameProperties(i.properties, original.properties); });
        if (!added || !stale) throw new Error('The new choice was added, but the old line changed. Review your cart before checkout; nothing was removed.');
        return api('/cart/change.js', { id: stale.key, quantity: 0 }).catch(function () {
          throw new Error('The new choice was added, but the old one could not be removed. Review both lines before checkout.');
        });
      });
    }).then(refresh).catch(function (error) {
      if (!replacementAdded) throw error;
      var message = error.message.indexOf('new choice was added') !== -1 ? error.message : 'The new choice was added, but the cart could not be verified. Review your cart before trying again.';
      return refresh().catch(function () {}).then(function () { throw new Error(message); });
    });
  }

  function removeKey(key) {
    cartDirty = true;
    api('/cart/change.js', { id: key, quantity: 0 }).then(refresh).catch(showError);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!el('np-drawer')) return;

    el('np-scrim').addEventListener('click', close);
    el('npd-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (el('fit-dialog') && el('fit-dialog').open) return;
      if (!el('np-drawer').classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var focusable = Array.from(el('np-drawer').querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])')).filter(function (x) { return x.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    document.querySelectorAll('.nav-cart').forEach(function (n) {
      n.addEventListener('click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        refresh().then(open).catch(function (error) { open(); showError(error); });
      });
    });

    document.querySelectorAll('[data-cart-edit-key]').forEach(function (button) {
      button.addEventListener('click', function () {
        refresh().then(function () {
          open();
          var select = Array.from(el('npd-items').querySelectorAll('[data-edit-key]')).find(function (x) { return x.dataset.editKey === button.dataset.cartEditKey; });
          if (select) { select.closest('details').open = true; select.focus(); }
          else showError(new Error('This legacy item can be removed here, but its current options are no longer offered.'));
        }).catch(showError);
      });
    });

    el('npd-items').addEventListener('click', function (e) {
      var save = e.target.closest('.npd-save-edit');
      if (save) {
        if (save.disabled) return;
        save.disabled = true; save.textContent = 'Saving…';
        swapLine(save.closest('.npd-edit')).catch(showError).finally(function () { save.disabled = false; save.textContent = 'Save'; });
        return;
      }
      var rm = e.target.closest('.rm');
      if (!rm) return;
      if (rm.dataset.demoRm !== undefined) {
        var c = demoCart(); c.items.splice(parseInt(rm.dataset.demoRm, 10), 1); demoSave(c); refresh();
      } else if (rm.dataset.key) {
        removeKey(rm.dataset.key);
      }
    });

    // product form intercept
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (document.body.classList.contains('template-cart') && !demo) return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = parseInt(f.querySelector('[name="id"]').value, 10);
        var items = [{ id: vid, quantity: 1 }];
        var metas = [collectPageMeta(f)];
        if (f.dataset.busy === 'true' || checkoutStarted) return;
        if (window.NPKit && !window.NPKit.valid) { showError(new Error('Please choose an available color and size for each item.')); return; }
        if (window.NPKit && window.NPKit.on && window.NPKit.companionVariant) {
          items.push({ id: window.NPKit.companionVariant, quantity: 1 });
          metas.push(window.NPKit.companionMeta);
        }
        var button = f.querySelector('[type="submit"]'), label = button.textContent;
        var controls = Array.from(f.querySelectorAll('button,input,select')).concat(el('sa-btn') ? [el('sa-btn')] : []);
        var states = controls.map(function (control) { return control.disabled; });
        f.dataset.busy = 'true'; controls.forEach(function (control) { control.disabled = true; }); button.textContent = 'Adding…';
        if (el('purchase-error')) el('purchase-error').hidden = true;
        var intent = f.dataset.intent === 'checkout' ? 'checkout' : 'cart';
        f.dataset.intent = '';
        addItems(items, metas, intent).catch(showError).finally(function () { if (!checkoutStarted) { f.dataset.busy = 'false'; controls.forEach(function (control, index) { control.disabled = states[index]; }); button.textContent = label; } });
      });
    });

    // booties one-click inside the drawer
    var upAdd = el('npd-upsell-add');
    if (upAdd) {
      upAdd.addEventListener('click', function () {
        if (upAdd.disabled) return;
        var color = drawerPick.color, size = drawerPick.size;
        var v = (D.bootiesVariants || []).find(function (b) { return b.color === color && b.size === size; });
        if (!v || !v.available) { showError(new Error('Please choose an available booties size and color.')); return; }
        var label = upAdd.textContent;
        upAdd.disabled = true; upAdd.textContent = 'Adding…';
        addItems([{ id: v.id, quantity: 1 }],
                 [{ title: D.bootiesTitle, meta: color + ' / ' + size, img: D.bootiesImg, cents: v.cents, handle: D.bootiesHandle }]).catch(showError).finally(function () { upAdd.disabled = false; upAdd.textContent = label; });
      });
    }

    // drawer booties pills
    var firstBoot = (D.bootiesVariants || []).find(function (v) { return v.available && D.kitColors.indexOf(v.color) !== -1; }) || {};
    var drawerPick = { color: firstBoot.color, size: '' };
    window.drawerPick = drawerPick;
    function refreshDrawerPick() {
      var v = (D.bootiesVariants || []).find(function (b) { return b.color === drawerPick.color && b.size === drawerPick.size; });
      if (upAdd) upAdd.disabled = !v || !v.available;
      var photo = el('npd-upsell-image');
      if (photo && v && window.MitsiVariantImages[v.id]) {
        photo.src = window.MitsiVariantImages[v.id];
        photo.alt = drawerPick.color + ' fleece-lined winter booties, set of four';
      }
    }
    document.querySelectorAll('#npd-upsell .kbp-pill').forEach(function (p) {
      p.classList.toggle('on', drawerPick[p.dataset.g] === p.dataset.v);
      p.addEventListener('click', function () {
        if (p.disabled) return;
        drawerPick[p.dataset.g] = p.dataset.v;
        document.querySelectorAll('#npd-upsell .kbp-pill[data-g="' + p.dataset.g + '"]').forEach(function (x) { x.classList.remove('on'); });
        p.classList.add('on');
        refreshDrawerPick();
      });
    });
    refreshDrawerPick();
    var cartSelect = document.querySelector('.cart-upsell-select');
    if (cartSelect) {
      var refreshCartPhoto = function () {
        var photo = el('cart-upsell-image');
        var v = (D.bootiesVariants || []).find(function (b) { return String(b.id) === cartSelect.value; });
        if (photo && v && window.MitsiVariantImages[v.id]) {
          photo.src = window.MitsiVariantImages[v.id];
          photo.alt = v.color + ' fleece-lined winter booties, set of four';
        }
      };
      cartSelect.addEventListener('change', refreshCartPhoto);
      refreshCartPhoto();
    }

    function collectPageMeta(form) {
      var t = document.querySelector('.pdp-buy h1');
      var img = document.getElementById('pdp-main');
      var color = document.getElementById('current-color');
      var size = document.getElementById('current-size');
      var vid = form.querySelector('[name="id"]').value;
      var v = (window.variants || D.bootiesVariants || []).find(function (x) { return String(x.id) === vid; });
      if (!t && v) return {title: D.bootiesTitle, meta: v.color + ' / ' + v.size, img: D.bootiesImg, cents: v.cents, handle: D.bootiesHandle};
      return { title: v && v.handle ? (v.handle === D.bootiesHandle ? D.bootiesTitle : 'Quilted Vest') : (t ? t.textContent : 'Item'),
               meta: (color ? color.textContent : '') + (size ? ' / ' + size.textContent : ''),
               img: img ? img.src : '', cents: v ? v.cents : 0,
               handle: v && v.handle ? v.handle : (location.pathname.split('/products/')[1] ? location.pathname.split('/products/')[1].split('?')[0].replace(/\/$/, '') : '') };
    }
    function bootiesMetaLabel(vid) {
      var v = (D.bootiesVariants || []).find(function (b) { return b.id === vid; });
      return v ? v.color + ' / ' + v.size : '';
    }

    refresh().catch(showError);
    window.addEventListener('pageshow', function (event) { if (event.persisted) window.location.reload(); });
  });
  function showError(error) {
    var out = el('purchase-error');
    if (out) { out.textContent = error.message || 'We could not update your cart. Please try again.'; out.hidden = false; }
    var drawer = el('npd-error');
    if (drawer) { drawer.textContent = error.message || 'We could not update your cart. Please try again.'; drawer.hidden = false; }
  }
})();
